import axios from 'axios'
import { message } from 'antd'

const baseURL = 'https://travel-merchant-api.gdhttech.com/'
// const baseURL = 'http://192.168.8.174:90/'
// 房展才的接口地址
// const baseURL = 'http://travel-merchant-api.blogwiki.top/'
// 商户端接口
// const baseURL = 'http://travel-merchant-api.blogwiki.top/'
// const baseURL = 'http://travel-merchant-api.dev.blogwiki.top/'
// const baseURL = 'http://travel-merchant-api.blogwiki.top/'
// const baseURL = 'http://travel-merchant-api.dev.blogwiki.top/'

export const updateUrl = baseURL + '/file/upload'

// console.log(`当前模式${process.env.NODE_ENV}, 接口地址${baseURL}`)

const instance = axios.create({
  baseURL,
  timeout: 30000,
})

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    message.destroy()
    switch (error.response.status) {
    // 未登录
    case 400:
      message.error(error.response.data || '账号不存在', 2)
      break
    case 401:
      message.error(error.response.data, 2, () => {
        if (window._ROUTER_.location.pathname !== '/login') {
          let q = window.location.hash
          q = q.substring(q.indexOf('#') + 1)
          window._ROUTER_.history.push('/login?q=' + encodeURIComponent(q))
        }
      })
      return false
    default:
      message.error('请求失败', 2)
      break
    }
    // 返回接口返回的错误信息
    return Promise.reject(error) 
  }
)

function NetData (method, url, params) {
  const userinfo = localStorage.getItem('access_info')
  return new Promise((resove, reject = () => {}) => {
    return instance({
      url,
      method,
      headers: {
        'Content-Type': 'application/json',
        'X-Request-Token': userinfo ? JSON.parse(userinfo).token : '',
      },
      params: method === 'GET' ? params : null,
      data: method !== 'GET' ? params : null,
    })
      .then(res => {
        if (res.status === 200) {
          resove({data: res.data, date: res.headers.date}) 
        }
        else {
          reject(res)
        }
      })
      .catch(error => {
        console.log('wwwwwwww')
        reject(error) 
      })
  })
}

export default {
  put: (url, params = {}) => NetData('PUT', url, params),
  get: (url, params = {}) => NetData('GET', url, params),
  post: (url, params = {}) => NetData('POST', url, params),
  patch: (url, params = {}) => NetData('PATCH', url, params),
  delete: (url) => NetData('DELETE', url),
  baseURL
}